import { ModuleBase, Button, Text, HeadingTag } from '@/components';
import DownloadIcon from '@/assets/download.svg';
import { motion } from 'framer-motion';

const DetailListModule = ({ data }) => {
  const { headingTitle, description, preHeading, primaryCta, details } = data || {};

  return (
    <ModuleBase data={data} className="bg-off-white">
      <div className="container flex flex-col gap-16 px-6 py-6 sm:py-16 md:flex-row md:gap-6 md:px-10 lg:justify-between lg:gap-[104px] lg:px-[156px] lg:py-[104px]">
        <div className="md:w-1/2 md:pr-[49px] lg:w-[420px] lg:p-0">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut', delay: 0 }}
            viewport={{ once: true, amount: 0.05 }}
          >
            {preHeading && (
              <Text className="mb-3 font-gotham text-sm font-n-light leading-6 text-black/75">{preHeading}</Text>
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut', delay: 0.2 }}
            viewport={{ once: true, amount: 0.05 }}
          >
            {headingTitle && (
              <HeadingTag
                animate
                data={headingTitle}
                className="mb-8 font-larken text-2xl font-light leading-7 text-black md:mb-12 md:text-desktop-medium md:leading-desktop-medium"
              />
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut', delay: 0.4 }}
            viewport={{ once: true, amount: 0.05 }}
          >
            {description && (
              <div
                className="mb-8 font-gotham text-sm font-s-light leading-6 text-black/75 lg:mb-14"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut', delay: 0.6 }}
            viewport={{ once: true, amount: 0.05 }}
          >
            {primaryCta && (
              <Button link={primaryCta} className="btn secondary dark w-full sm:w-auto">
                <DownloadIcon />
              </Button>
            )}
          </motion.div>
        </div>

        {details.length > 0 && (
          <div className="flex w-full flex-col md:w-1/2 md:pt-[72px] xl:w-[664px] xl:pb-6 xl:pt-20">
            {details.map((element, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: 'easeOut', delay: index * 0.05 }}
                viewport={{ once: true, amount: 0.05 }}
                className="flex flex-col gap-4 border-b border-dashed border-black/25 py-4 font-gotham first:pt-0 last:border-none last:pb-0 md:py-6 xl:flex-row xl:gap-8 xl:px-4"
              >
                <Text className="text-base font-n-light tracking-paragraph xl:min-w-[200px]">
                  {element.statisticsLabel}
                </Text>
                <Text
                  className="richtext-content text-sm font-s-light leading-6 text-black/75 [&_ol]:m-0 [&_ul]:m-0"
                  dangerouslySetInnerHTML={{ __html: element.statistics }}
                />
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </ModuleBase>
  );
};

export default DetailListModule;
